var render = function render(){
  var _vm$info, _vm$info$info, _vm$info$info$file, _vm$info2, _vm$info2$info, _vm$info2$info$file, _vm$info3, _vm$info3$info, _vm$info3$info$meta, _vm$info3$info$meta$s, _vm$info4, _vm$info4$info, _vm$info4$info$meta, _vm$info4$info$meta$p, _vm$info5, _vm$info5$info, _vm$info5$info$file, _vm$get, _vm$get2, _vm$info6, _vm$info6$info, _vm$info6$info$file, _vm$info7, _vm$info7$info, _vm$info7$info$meta, _vm$info8, _vm$info8$info, _vm$info8$info$meta, _vm$info9, _vm$info9$info, _vm$info9$info$meta, _vm$info9$info$meta$t, _vm$info0, _vm$info0$info, _vm$info0$info$meta, _vm$info1, _vm$info1$info, _vm$info1$info$file, _vm$info10, _vm$info10$info, _vm$info10$info$meta, _vm$info10$info$meta$, _vm$info11, _vm$info11$info, _vm$info11$info$meta, _vm$info11$info$meta$, _vm$info12, _vm$info12$info, _vm$info12$info$meta, _vm$info12$info$meta$, _vm$info13, _vm$info13$info, _vm$info13$info$meta, _vm$get3, _vm$info$info$warning, _vm$info$info$warning2, _vm$info$info$warning3, _vm$get4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "release-info"
  }, [_c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('v-card-title', {
    staticClass: "display-1 justify-center mb-5"
  }, [_vm._v("Info")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v(" " + _vm._s(_vm.get(_vm.info, "info.file.extension", "") == "apk" ? "Android" : "iOS") + " ")])])], 1), _c('v-expansion-panels', {
    attrs: {
      "flat": "",
      "multiple": ""
    },
    model: {
      value: _vm.topPanel,
      callback: function callback($$v) {
        _vm.topPanel = $$v;
      },
      expression: "topPanel"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v(" " + _vm._s(_vm.get(_vm.info, "info.file.extension", "") == "apk" ? "APK" : "IPA") + " ")])]), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "px-6 font14 info-height"
  }, [_c('div', [_vm._v(" Name: " + _vm._s(_vm.info && _vm.info.info.name ? _vm.info.info.name : _vm.app.name) + " ")]), _c('div', [_vm._v("Signing: " + _vm._s(_vm.get(_vm.info, "info.meta.signingType", "")))]), _c('div', [_vm._v(" " + _vm._s(((_vm$info = _vm.info) === null || _vm$info === void 0 ? void 0 : (_vm$info$info = _vm$info.info) === null || _vm$info$info === void 0 ? void 0 : (_vm$info$info$file = _vm$info$info.file) === null || _vm$info$info$file === void 0 ? void 0 : _vm$info$info$file.extension) === "apk" ? "Package" : "Bundle ID") + ": " + _vm._s(_vm.get(_vm.info, "info.package", "")) + " ")]), _c('div', [_vm._v("Version: " + _vm._s(_vm.get(_vm.info, "info.version", "")))]), _c('div', [_vm._v(" " + _vm._s(((_vm$info2 = _vm.info) === null || _vm$info2 === void 0 ? void 0 : (_vm$info2$info = _vm$info2.info) === null || _vm$info2$info === void 0 ? void 0 : (_vm$info2$info$file = _vm$info2$info.file) === null || _vm$info2$info$file === void 0 ? void 0 : _vm$info2$info$file.extension) === "apk" ? " Version Code" : "Bundle Number") + " : " + _vm._s(_vm.get(_vm.info, "info.version_code", "")) + " ")]), _vm.get(_vm.info, 'info.file.extension', '') == 'apk' ? _c('div', [_vm._v(" Target SDK: " + _vm._s(_vm.get(_vm.info, "info.meta.targetSDKVersion", "")) + " ")]) : _vm._e(), _vm.get(_vm.info, 'info.file.extension', '') == 'apk' ? _c('div', [_vm._v(" Min SDK: " + _vm._s(_vm.get(_vm.info, "info.meta.minSDKVersion", "")) + " ")]) : _vm._e(), _vm.get(_vm.info, 'info.file.extension', '') == 'ipa' ? _c('div', [_vm._v(" Platform Version: " + _vm._s(_vm.get(_vm.info, "info.meta.platformVersion", "")) + " ")]) : _vm._e(), _vm.get(_vm.info, 'info.file.extension', '') == 'ipa' ? _c('div', [_vm._v(" Min OS: " + _vm._s(_vm.get(_vm.info, "info.meta.minimumOSVersion", "")) + " ")]) : _vm._e(), _vm.get(_vm.info, 'info.file.extension', '') == 'ipa' ? _c('div', [_vm._v(" Supported Platforms: " + _vm._s((_vm$info3 = _vm.info) === null || _vm$info3 === void 0 ? void 0 : (_vm$info3$info = _vm$info3.info) === null || _vm$info3$info === void 0 ? void 0 : (_vm$info3$info$meta = _vm$info3$info.meta) === null || _vm$info3$info$meta === void 0 ? void 0 : (_vm$info3$info$meta$s = _vm$info3$info$meta.supportedPlatforms) === null || _vm$info3$info$meta$s === void 0 ? void 0 : _vm$info3$info$meta$s.join(", ")) + " ")]) : _vm._e(), _vm.get(_vm.info, 'info.file.extension', '') == 'ipa' ? _c('div', [_vm._v(" Platforms: " + _vm._s((_vm$info4 = _vm.info) === null || _vm$info4 === void 0 ? void 0 : (_vm$info4$info = _vm$info4.info) === null || _vm$info4$info === void 0 ? void 0 : (_vm$info4$info$meta = _vm$info4$info.meta) === null || _vm$info4$info$meta === void 0 ? void 0 : (_vm$info4$info$meta$p = _vm$info4$info$meta.platforms) === null || _vm$info4$info$meta$p === void 0 ? void 0 : _vm$info4$info$meta$p.join(", ")) + " ")]) : _vm._e(), _c('div', [_vm._v(" Size: " + _vm._s(_vm.formatBytes(_vm.get(_vm.info, "info.file.size", 0) / 1000)) + " ")]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" File name: " + _vm._s(_vm.get(_vm.info, "info.file.name", "")) + " ")])])])], 1), ((_vm$info5 = _vm.info) === null || _vm$info5 === void 0 ? void 0 : (_vm$info5$info = _vm$info5.info) === null || _vm$info5$info === void 0 ? void 0 : (_vm$info5$info$file = _vm$info5$info.file) === null || _vm$info5$info$file === void 0 ? void 0 : _vm$info5$info$file.extension) === 'apk' ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v("Permissions")])]), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "px-9 mb-9 mt-3 font14 info-height",
    class: (_vm$get = _vm.get(_vm.info, 'info.meta.usesPermissions', [])) !== null && _vm$get !== void 0 && _vm$get.length ? 'scrollBar' : ''
  }, [(_vm$get2 = _vm.get(_vm.info, 'info.meta.usesPermissions', [])) !== null && _vm$get2 !== void 0 && _vm$get2.length ? _c('permission-mapper', {
    attrs: {
      "permissions": _vm.get(_vm.info, 'info.meta.usesPermissions', [])
    }
  }) : _c('div', {
    staticClass: "font14 info-height ml-n3"
  }, [_vm._v(" No permissions found ")])], 1)])], 1) : _vm._e(), ((_vm$info6 = _vm.info) === null || _vm$info6 === void 0 ? void 0 : (_vm$info6$info = _vm$info6.info) === null || _vm$info6$info === void 0 ? void 0 : (_vm$info6$info$file = _vm$info6$info.file) === null || _vm$info6$info$file === void 0 ? void 0 : _vm$info6$info$file.extension) === 'ipa' ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v("Certificate")])]), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "ml-5 font14 info-height"
  }, [_c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Created:")]), _c('span', {
    staticClass: "ml-3"
  }, [_c('date-tooltip', {
    attrs: {
      "date": (_vm$info7 = _vm.info) === null || _vm$info7 === void 0 ? void 0 : (_vm$info7$info = _vm$info7.info) === null || _vm$info7$info === void 0 ? void 0 : (_vm$info7$info$meta = _vm$info7$info.meta) === null || _vm$info7$info$meta === void 0 ? void 0 : _vm$info7$info$meta.creationDate
    }
  }), _vm._v(" " + _vm._s())], 1)]), _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Expire:")]), _c('span', {
    staticClass: "ml-3"
  }, [_c('date-tooltip', {
    attrs: {
      "date": (_vm$info8 = _vm.info) === null || _vm$info8 === void 0 ? void 0 : (_vm$info8$info = _vm$info8.info) === null || _vm$info8$info === void 0 ? void 0 : (_vm$info8$info$meta = _vm$info8$info.meta) === null || _vm$info8$info$meta === void 0 ? void 0 : _vm$info8$info$meta.expirationDate
    }
  })], 1)]), _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Team Identifier:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(" " + _vm._s(((_vm$info9 = _vm.info) === null || _vm$info9 === void 0 ? void 0 : (_vm$info9$info = _vm$info9.info) === null || _vm$info9$info === void 0 ? void 0 : (_vm$info9$info$meta = _vm$info9$info.meta) === null || _vm$info9$info$meta === void 0 ? void 0 : (_vm$info9$info$meta$t = _vm$info9$info$meta.teamIdentifier) === null || _vm$info9$info$meta$t === void 0 ? void 0 : _vm$info9$info$meta$t.join(", ")) || "-") + " ")])]), _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Provisioning profile name:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(" " + _vm._s((_vm$info0 = _vm.info) === null || _vm$info0 === void 0 ? void 0 : (_vm$info0$info = _vm$info0.info) === null || _vm$info0$info === void 0 ? void 0 : (_vm$info0$info$meta = _vm$info0$info.meta) === null || _vm$info0$info$meta === void 0 ? void 0 : _vm$info0$info$meta.provisioningProfileName) + " ")])])])])], 1) : _vm._e(), ((_vm$info1 = _vm.info) === null || _vm$info1 === void 0 ? void 0 : (_vm$info1$info = _vm$info1.info) === null || _vm$info1$info === void 0 ? void 0 : (_vm$info1$info$file = _vm$info1$info.file) === null || _vm$info1$info$file === void 0 ? void 0 : _vm$info1$info$file.extension) === 'ipa' ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v(" Provisioned Devices (" + _vm._s(((_vm$info10 = _vm.info) === null || _vm$info10 === void 0 ? void 0 : (_vm$info10$info = _vm$info10.info) === null || _vm$info10$info === void 0 ? void 0 : (_vm$info10$info$meta = _vm$info10$info.meta) === null || _vm$info10$info$meta === void 0 ? void 0 : (_vm$info10$info$meta$ = _vm$info10$info$meta.provisionedDevices) === null || _vm$info10$info$meta$ === void 0 ? void 0 : _vm$info10$info$meta$.length) || "0") + " / 100) ")])]), _c('v-expansion-panel-content', [(_vm$info11 = _vm.info) !== null && _vm$info11 !== void 0 && (_vm$info11$info = _vm$info11.info) !== null && _vm$info11$info !== void 0 && (_vm$info11$info$meta = _vm$info11$info.meta) !== null && _vm$info11$info$meta !== void 0 && (_vm$info11$info$meta$ = _vm$info11$info$meta.provisionedDevices) !== null && _vm$info11$info$meta$ !== void 0 && _vm$info11$info$meta$.length ? _c('div', {
    staticClass: "ml-5 font14 info-height",
    class: (_vm$info12 = _vm.info) !== null && _vm$info12 !== void 0 && (_vm$info12$info = _vm$info12.info) !== null && _vm$info12$info !== void 0 && (_vm$info12$info$meta = _vm$info12$info.meta) !== null && _vm$info12$info$meta !== void 0 && (_vm$info12$info$meta$ = _vm$info12$info$meta.provisionedDevices) !== null && _vm$info12$info$meta$ !== void 0 && _vm$info12$info$meta$.length ? 'scrollBar' : ''
  }, _vm._l((_vm$info13 = _vm.info) === null || _vm$info13 === void 0 ? void 0 : (_vm$info13$info = _vm$info13.info) === null || _vm$info13$info === void 0 ? void 0 : (_vm$info13$info$meta = _vm$info13$info.meta) === null || _vm$info13$info$meta === void 0 ? void 0 : _vm$info13$info$meta.provisionedDevices, function (udid, uindex) {
    return _c('div', {
      key: uindex,
      staticClass: "mb-1"
    }, [_c('span', {
      staticClass: "mr-2"
    }, [_vm._v(" " + _vm._s(uindex + 1) + ". ")]), _c('span', [_vm._v(" " + _vm._s(udid) + " ")])]);
  }), 0) : _c('div', {
    staticClass: "font14 info-height ml-6"
  }, [_vm._v("No devices found")])])], 1) : _vm._e()], 1), !_vm.isExpress ? _c('v-row', {
    staticClass: "ml-3 my-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v("Members")]), _c('div', {
    staticClass: "font14 info-height"
  }, [_c('div', [_vm._v(" Total eligible: " + _vm._s(_vm.get(_vm.info, "meta.members.eligible", 0)) + " ")]), _vm.get(_vm.info, 'info.file.extension', '') == 'apk' ? _c('div', [_vm._v(" Total with Android: " + _vm._s(_vm.get(_vm.info, "meta.members.eligible_per_platform", 0)) + " ")]) : _vm._e(), _vm.get(_vm.info, 'info.file.extension', '') == 'ipa' ? _c('div', [_vm._v(" Total with iOS: " + _vm._s(_vm.get(_vm.info, "meta.members.eligible_per_platform", 0)) + " ")]) : _vm._e(), _c('div', [_vm._v(" Total with Android & iOS: " + _vm._s(_vm.get(_vm.info, "meta.members.total", 0)) + " ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v("Devices")]), _c('div', {
    staticClass: "font14 info-height"
  }, [_c('div', [_vm._v("Total: " + _vm._s(_vm.get(_vm.info, "meta.devices.total", 0)))]), _c('div', [_vm._v(" Total eligible: " + _vm._s(_vm.get(_vm.info, "meta.devices.total_eligible", 0)) + " ")]), _c('div', [_vm._v(" Total not eligible: " + _vm._s(_vm.get(_vm.info, "meta.devices.total_not_eligible", 0)) + " ")])])])], 1) : _vm._e(), _c('v-expansion-panels', {
    staticClass: "mb-5",
    attrs: {
      "flat": ""
    },
    model: {
      value: _vm.warning,
      callback: function callback($$v) {
        _vm.warning = $$v;
      },
      expression: "warning"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "headline darkGrey--text"
  }, [_vm._v("Warnings")])]), _c('v-expansion-panel-content', [!((_vm$get3 = _vm.get(_vm.info, 'meta.devices.members', [])) !== null && _vm$get3 !== void 0 && _vm$get3.length) && !(_vm.info && _vm.info.info.warnings && (_vm$info$info$warning = _vm.info.info.warnings) !== null && _vm$info$info$warning !== void 0 && _vm$info$info$warning.length) ? [_c('div', {
    staticClass: "d-flex flex-center text-center min-h-200px"
  }, [_c('div', {
    staticClass: "no-data-found mx-auto"
  }, [_c('inline-svg', {
    staticClass: "mt-6 svg-icon empty_icon",
    attrs: {
      "src": "/media/placeholders/check.svg"
    }
  }), _c('p', {
    staticClass: "mt-2 empty-title bold-text darkGrey--text text-center"
  }, [_vm._v(" All looks good ")])], 1)])] : [_vm.info && _vm.info.info.warnings && (_vm$info$info$warning2 = _vm.info.info.warnings) !== null && _vm$info$info$warning2 !== void 0 && _vm$info$info$warning2.length ? _c('v-expansion-panels', [_c('v-expansion-panel', {
    staticClass: "mb-2"
  }, [_c('v-expansion-panel-header', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.get(_vm.info, "info.file.extension", "") == "apk" ? "APK" : "IPA") + " warnings ")]), _c('v-chip', {
    staticClass: "font-weight-bold",
    attrs: {
      "color": "orange",
      "small": ""
    },
    domProps: {
      "textContent": _vm._s((_vm$info$info$warning3 = _vm.info.info.warnings) === null || _vm$info$info$warning3 === void 0 ? void 0 : _vm$info$info$warning3.length)
    }
  })], 1)], 1)], 1), _c('v-expansion-panel-content', {
    staticClass: "pa-0"
  }, [_c('v-card', {
    staticClass: "pa-4 mb-2",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('ul', _vm._l(_vm.info.info.warnings, function (warning, j) {
    return _c('li', {
      key: j
    }, [_vm._v(" " + _vm._s(warning) + " ")]);
  }), 0)])], 1)], 1)], 1) : _vm._e(), (_vm$get4 = _vm.get(_vm.info, 'meta.devices.members', [])) !== null && _vm$get4 !== void 0 && _vm$get4.length && !_vm.isExpress ? _c('div', {
    staticClass: "darkGrey--text font17 py-4 ml-6"
  }, [_vm._v(" Devices ")]) : _vm._e(), _vm.info && _vm.info.meta && _vm.info.meta.devices && !_vm.isExpress ? _c('v-expansion-panels', _vm._l(_vm.get(_vm.info, 'meta.devices.members', []), function (member, i) {
    var _vm$info14, _vm$info14$info, _vm$info15, _vm$info15$info, _member$devices;
    return _c('v-expansion-panel', {
      key: i,
      attrs: {
        "outline": ""
      }
    }, [_c('v-expansion-panel-header', [_c('v-row', {
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [(_vm$info14 = _vm.info) !== null && _vm$info14 !== void 0 && (_vm$info14$info = _vm$info14.info) !== null && _vm$info14$info !== void 0 && _vm$info14$info.icon ? _c('img', {
      attrs: {
        "src": (_vm$info15 = _vm.info) === null || _vm$info15 === void 0 ? void 0 : (_vm$info15$info = _vm$info15.info) === null || _vm$info15$info === void 0 ? void 0 : _vm$info15$info.icon,
        "height": "50"
      }
    }) : _c('img', {
      attrs: {
        "height": "50",
        "src": "/media/defaults/icon-120.png"
      }
    })]), _c('v-col', {
      staticClass: "text-left"
    }, [_c('div', [_vm._v(_vm._s(member.name))]), _c('div', {
      staticClass: "mr-4 mt-2"
    }, [_vm._v(" " + _vm._s(member === null || member === void 0 ? void 0 : (_member$devices = member.devices) === null || _member$devices === void 0 ? void 0 : _member$devices.length) + " devices are not eligible ")])])], 1)], 1), _c('v-expansion-panel-content', _vm._l(member.devices, function (device, j) {
      return _c('v-card', {
        key: j,
        staticClass: "pa-4 mb-2",
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('div', {
        staticClass: "font14 info-height"
      }, [_c('v-row', [_c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("OS:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.os) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("Name:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.name) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("Type:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.type) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("Model:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.model) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("Language:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.locale) || (device === null || device === void 0 ? void 0 : device.language) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("Manufacturer:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.manufacturer) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("Notifications Enabled:")]), _vm._v(" " + _vm._s(device !== null && device !== void 0 && device.push_enabled ? "Yes" : "No" || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("SDK version:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.sdk_version) || "---") + " ")]), _c('v-col', {
        staticClass: "py-0 d-flex justify-space-between",
        attrs: {
          "cols": "12",
          "md": "4",
          "sm": "6"
        }
      }, [_c('span', {
        staticClass: "bold-text mr-2"
      }, [_vm._v("OS version:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.os_version) || "---") + " ")])], 1), _c('div', {
        staticClass: "mr-2 mt-3"
      }, [_c('span', {
        staticClass: "bold-text"
      }, [_vm._v("UUID:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.uuid) || "---") + " "), device.uuid ? _c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": function click($event) {
            return _vm.copy(device.uuid);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        },
        domProps: {
          "textContent": _vm._s('mdi-content-copy')
        }
      })], 1) : _vm._e()], 1), device.os.toLowerCase() == 'ios' ? _c('div', {
        staticClass: "mr-2 mt-3"
      }, [_c('span', {
        staticClass: "bold-text"
      }, [_vm._v("UDID:")]), _vm._v(" " + _vm._s((device === null || device === void 0 ? void 0 : device.udid) || "---") + " "), device.udid ? _c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": function click($event) {
            return _vm.copy(device.udid);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "16"
        },
        domProps: {
          "textContent": _vm._s('mdi-content-copy')
        }
      })], 1) : _vm._e()], 1) : _vm._e(), _c('div', {
        staticClass: "bold-text mr-2 mt-3"
      }, [_vm._v("Messages")]), _vm._l(device === null || device === void 0 ? void 0 : device.messages, function (message, k) {
        return _c('div', {
          key: k
        }, [_c('div', {
          staticClass: "mr-2 mt-3"
        }, [_c('b', [_vm._v(_vm._s(k + 1))]), _vm._v(". "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(message)
          }
        })])]);
      })], 2)]);
    }), 1)], 1);
  }), 1) : _vm._e()]], 2)], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }